import { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";

const CommonMapDefaultItem = ({ current, onCurrentChanged }) => {
  const map = useMap();

  useEffect(() => {
    if (map && current && current.lastPosition) {
      map.panTo({
        lat: Number(current.lastPosition.latitude),
        lng: Number(current.lastPosition.longitude),
      });
      // map.setZoom(18);
    }
  }, [map, current]);

  return null;
};

export default CommonMapDefaultItem;
